// Copyright (c) 2022-2023. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { useAuthSession } from "../../../../../../../io/hyperify/frontend/hooks/useAuthSession";
import {
    MY_LOGIN_VIEW_CLASS_NAME
} from "../../../../../core/constants/className";
import { MyLoginArticle } from "./MyLoginArticle";
import { useNavigate } from "react-router-dom";
import { MY_CLIENT_LIST_ROUTE } from "../../../../../core/constants/route";
import { Loader } from "../../../../../../../io/hyperify/frontend/components/loader/Loader";
import {
    T_MY_LOGIN_VIEW_TEXT,
    T_MY_LOGIN_VIEW_TITLE,
    T_MY_LOGIN_VIEW_REQUEST_CODE_TITLE,
    T_MY_LOGIN_VIEW_REQUEST_TEXT,
    T_MY_LOGIN_VIEW_SUBMIT_BUTTON_LABEL
} from "../../../../../core/constants/translation";
import "./MyLoginView.scss";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";

export interface MyLoginViewProps {
    readonly className ?: string;
    readonly t?: TranslationFunction;
}

export function MyLoginView (props: MyLoginViewProps) {

    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;

    const navigate = useNavigate();
    const session = useAuthSession();
    const email : string | undefined = session?.email;
    const sms : string | undefined = session?.sms;

    const translationParams = {
        EMAIL: email,
        SMS: sms,
    };

    if (session?.isLoggedIn) {
        navigate(MY_CLIENT_LIST_ROUTE);
        return <Loader />;
    }

    return (
        <div className={
            MY_LOGIN_VIEW_CLASS_NAME
            + (className? ` ${className}` : '')
        }>
            <MyLoginArticle
                t={t}
                translationParams={translationParams}
                title={t(T_MY_LOGIN_VIEW_TITLE, translationParams)}
                contentText={t(T_MY_LOGIN_VIEW_TEXT, translationParams)}
                submitButtonLabel={t(T_MY_LOGIN_VIEW_SUBMIT_BUTTON_LABEL, translationParams)}
                requestCodeTitle={t(T_MY_LOGIN_VIEW_REQUEST_CODE_TITLE, translationParams)}
                requestCodeText={t(T_MY_LOGIN_VIEW_REQUEST_TEXT, translationParams)}
            />
        </div>
    );

}
